import { render } from "./ServiceSelector.vue?vue&type=template&id=23ebe3d4"
import script from "./ServiceSelector.vue?vue&type=script&lang=js"
export * from "./ServiceSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__